import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fb64fd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "rel ml_20 guideDom-pure-all-5 guideDom-channel-all-1",
  id: "toggle-shop",
  style: {"max-width":"100px"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "flex-bwn",
  style: {"line-height":"24px","padding-left":"25px"}
}
const _hoisted_4 = {
  class: "line--only",
  style: {"max-width":"120px"}
}
const _hoisted_5 = { class: "ml_10" }
const _hoisted_6 = { class: "flex-ter shop-item" }
const _hoisted_7 = ["src"]

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import CreateShop from '../common/CreateShop.vue'
import { myShopIcons } from '@/store/modules/bussiness'
import bus from '@/util/useBus'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { bury } from '@/util/useBury'
import { TaEvent, taTrack } from '@/util/buryingPoint'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const shops = computed(() => store.getters.userShops)
/** 新增店铺 */
const createShops = () => {
  visible.value = true
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: 'add_shop'
    }
  })
}
// const shops = computed(() => [])
const curShop = computed({
  get: () => store.getters.curShop,
  set: (v) => {
    taTrack({
      event: TaEvent.BTN_CLICK,
      value: {
        position: 'switch_shop'
      }
    })
    store.dispatch('route/changeShop', v)
  }
})
const shopPlatform = computed(() => {
  return shops.value.find((v: any) => v.customerShopId === curShop.value)
    ?.shopPlatform
})

const select = ref()
const visible = ref(false)

bus.on('guide', (state: any) => {
  if (state.key === 'guide-createShop-dialog-show') {
    visible.value = true
  }
  if (state.key === 'guide-createShop-dialog-hide') {
    visible.value = false
  }
})

const selectVisible = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_main = _resolveDirective("main")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(shops).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            referrerPolicy: "no-referrer",
            src: _unref(myShopIcons)[_unref(shopPlatform)],
            class: "abs shop-icon"
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(shops).find((v) => v.customerShopId === _unref(curShop))?.customerShopName), 1),
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("i", {
                class: _normalizeClass([{ active: selectVisible.value }, 'fa fa-caret-down'])
              }, null, 2)
            ])
          ]),
          _createVNode(_component_el_select, {
            class: "abs",
            modelValue: _unref(curShop),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(curShop) ? (curShop).value = $event : null)),
            size: "small",
            ref: (_value, _refs) => {
              _refs['select'] = _value
              select.value = _value
            },
            style: {"top":"0","opacity":"0"},
            onVisibleChange: _cache[3] || (_cache[3] = e => selectVisible.value = e)
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shops), (v) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: v.customerShopId,
                  value: v.customerShopId,
                  label: v.customerShopName,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(bury)('ALL_Click_StoreChose')))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        referrerPolicy: "no-referrer",
                        src: _unref(myShopIcons)[v.shopPlatform],
                        class: "mr_5"
                      }, null, 8, _hoisted_7),
                      _createTextVNode(" " + _toDisplayString(v.customerShopName), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["value", "label"]))
              }), 128)),
              _withDirectives(_createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => {select.value.blur(); createShops()}),
                class: "btn fcolor text-ct shop-btn"
              }, [
                _createTextVNode(_toDisplayString(_unref(t)('快速创建')), 1)
              ], 512), [
                [_directive_main]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "ml_20 rel btn add-btn guideDom-pure-all-5 guideDom-channel-all-1 guideDom-createShop-all-1",
          onClick: createShops
        }, [
          _createVNode(SvgIcon, {
            style: {"font-size":"11px","margin-right":"3px"},
            name: "创建"
          }),
          _createElementVNode("span", null, _toDisplayString(_unref(t)('店铺追加')), 1)
        ])),
    (visible.value)
      ? (_openBlock(), _createBlock(CreateShop, {
          key: 2,
          modelValue: visible.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
          onClose: _cache[5] || (_cache[5] = ($event: any) => (visible.value = false)),
          onOk: _cache[6] || (_cache[6] = ($event: any) => (_unref(store).dispatch('route/updateUser')))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})